export default __webpack_public_path__ + "static/media/white-download.b953ce40.svg";